import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiMenu, FiX } from 'react-icons/fi';

const Navbar = ({ isScrolled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const scrollTo = (id) => {
    setIsOpen(false);
    if (isHome) {
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navLinks = [
    { name: 'About the Book', to: '/about-book' },
    { name: 'Read Excerpt', to: '/read-excerpt' },
    { name: 'The Author', to: '/author' },
    { name: 'Journal', to: '/blog' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">
        <Link to="/" className="font-serif text-xl md:text-2xl font-bold text-stone-900">
          The Silence Language
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-6">
          {navLinks.map((link) => (
            <Link key={link.name} to={link.to}
              className={`text-stone-600 hover:text-brand-700 font-medium transition-colors text-sm ${location.pathname === link.to ? 'text-brand-700 font-semibold' : ''}`}>
              {link.name}
            </Link>
          ))}
          <Link to="/about-book"
            onClick={() => { if (isHome) scrollTo('get-copy'); }}
            className="px-6 py-2.5 bg-stone-900 text-stone-50 rounded-full hover:bg-brand-700 transition-colors font-medium text-sm">
            Get Your Copy
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-stone-900 p-2" onClick={() => setIsOpen(!isOpen)}>
          <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-6 h-6" />
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="absolute top-full left-0 w-full bg-white shadow-lg py-4 px-6 md:hidden flex flex-col space-y-2"
        >
          {navLinks.map((link) => (
            <Link key={link.name} to={link.to} onClick={() => setIsOpen(false)}
              className="text-left text-stone-600 font-medium py-2 hover:text-brand-700 transition-colors">
              {link.name}
            </Link>
          ))}
          <Link to="/about-book" onClick={() => setIsOpen(false)}
            className="w-full px-6 py-3 bg-stone-900 text-stone-50 rounded-lg font-medium mt-2 text-center block">
            Get Your Copy
          </Link>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar;